export default "__VITE_ASSET__Dfn2Tnal__"